// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"688":"85623564","819":"cd8b862c"}[chunkId] + ".chunk.js";
};